import { APP_PREFIX_PATH } from "configs/AppConfig";

const overviewMenu = [
  {
    key: "menu",
    title: "Menu",
    breadcrumb: false,
    isGroupTitle: true,
    path: `${APP_PREFIX_PATH}`,
    submenu: [
      {
        key: "ringkasan",
        path: `${APP_PREFIX_PATH}/ringkasan`,
        title: "Ringkasan",
        layout: "blank",
        lock: false,
        breadcrumb: false,
      },
      {
        key: "data-pegawai",
        path: `${APP_PREFIX_PATH}/data-pegawai`,
        title: "Data Pegawai",
        layout: "satker",
        lock: false,
        breadcrumb: false,
      },
      // {
      //   key: "bko",
      //   path: `${APP_PREFIX_PATH}/bko`,
      //   title: "Mutasi",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      {
        key: "kenaikan-gaji-berkala",
        path: `${APP_PREFIX_PATH}/kgb`,
        title: "Kenaikan Gaji Berkala",
        layout: "blank",
        lock: false,
        breadcrumb: false,
        incomplete: true,
      },
      // {
      //   key: "bko",
      //   path: `${APP_PREFIX_PATH}/bko`,
      //   title: "BKO",
      //   layout: "blank",
      //   lock: false,
      //   breadcrumb: false,
      // },
      {
        key: "penunjukan-plh",
        path: `${APP_PREFIX_PATH}/penunjukan-plh`,
        title: "Penunjukan PLH",
        layout: "blank",
        lock: false,
        breadcrumb: false,
        incomplete: true,
      },
      {
        key: "tunpas",
        path: `${APP_PREFIX_PATH}/tunpas`,
        title: "Tunjangan Pemasyarakatan",
        layout: "blank",
        lock: false,
        breadcrumb: false,
        incomplete: true,
      },
      {
        key: "slks",
        path: `${APP_PREFIX_PATH}/slks`,
        title: "SLKS",
        layout: "blank",
        lock: false,
        breadcrumb: false,
        incomplete: true,
      },
      // {
      //   key: "kenaikan-pangkat",
      //   path: `${APP_PREFIX_PATH}/kenaikan-pangkat`,
      //   title: "Kenaikan Pangkat",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      {
        key: "diklat-ukom",
        path: `${APP_PREFIX_PATH}/diklat-ukom`,
        title: "Diklat/Ukom",
        access: "kanwil",
        layout: "blank",
        lock: false,
        breadcrumb: false,
      },
      {
        key: "file",
        path: `${APP_PREFIX_PATH}/arsip-file`,
        title: "Arsip File",
        layout: "blank",
        lock: false,
        breadcrumb: false,
        incomplete: true,
      },
      // {
      //   key: "penghargaan",
      //   path: `${APP_PREFIX_PATH}/penghargaan`,
      //   title: "Penghargaan",
      //   layout: "blank",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "pensiun",
      //   path: `${APP_PREFIX_PATH}/pensiun`,
      //   title: "Pensiun",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "seleksi-pi-udin",
      //   path: `${APP_PREFIX_PATH}/seleksi-pi-udin`,
      //   title: "Seleksi PI & Udin",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "kenaikan-pangkat",
      //   path: `${APP_PREFIX_PATH}/kenaikan-pangkat`,
      //   title: "Kenaikan Pangkat",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "pencantuman-gelar",
      //   path: `${APP_PREFIX_PATH}/pencantuman-gelar`,
      //   title: "Pencantuman Gelar",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "peninjauan-masa-kerja",
      //   path: `${APP_PREFIX_PATH}/peninjauan-masa-kerja`,
      //   title: "Peninjauan Masa Kerja",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "tugas-izin-belajar",
      //   path: `${APP_PREFIX_PATH}/tugas-izin-belajar`,
      //   title: "Tugas/Izin Belajar",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "kelas-jabatan",
      //   path: `${APP_PREFIX_PATH}/kelas-jabatan`,
      //   title: "Perubahan Kelas Jabatan",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "mutasi",
      //   path: `${APP_PREFIX_PATH}/mutasi`,
      //   title: "Mutasi",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "disiplin-pegawai",
      //   path: `${APP_PREFIX_PATH}/disiplin-pegawai`,
      //   title: "Disiplin Pegawai",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "izin-magang",
      //   path: `${APP_PREFIX_PATH}/izin-magang`,
      //   title: "Izin Magang",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "analisa-beban-kerja",
      //   path: `${APP_PREFIX_PATH}/analisa-beban-kerja`,
      //   title: "Analisa Beban Kerja",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "beasiswa",
      //   path: `${APP_PREFIX_PATH}/beasiswa`,
      //   title: "Beasiswa",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
      // {
      //   key: "biaya-mutasi",
      //   path: `${APP_PREFIX_PATH}/biaya-mutasi`,
      //   title: "Biaya Mutasi",
      //   layout: "satker",
      //   lock: true,
      //   breadcrumb: false,
      // },
    ],
  },
];

export default overviewMenu;
